import _ from 'lodash';
import React, { useState } from 'react';
import { InteractiveText, Queue, Stack, Text } from '../../components';

export const Navigation = (props) => {
  const rows = 6;
  let { children, desktop } = props;
  let components = React.Children.toArray(children);
  let length = components.length;
  const [index, setIndex] = useState(0);
  const [counter, setCounter] = useState(0);

  const handlePrev = () => {
    setIndex((prev) =>
      prev === 0 ? length - (rows - (length % rows)) : prev - rows
    );
    setCounter((prev) =>
      prev === 0 ? Math.ceil(length / rows) - 1 : prev - 1
    );
  };
  const handleNext = () => {
    setIndex((prev) => (prev + rows >= length ? 0 : prev + rows));
    setCounter((prev) => (prev + 1 >= length / rows ? 0 : prev + 1));
  };
  return (
    <Stack size={5}>
      {_.flow((components) => _.slice(components, index, index + rows))(
        components
      )}
      <Queue
        center={desktop}
        size={desktop && 9}
        justifyContent="space-between"
      >
        <InteractiveText
          textType="primary6"
          opacity={0.5}
          underlined
          onClick={handlePrev}
        >
          {'< Prev'}
        </InteractiveText>
        <Text textType="primary5">
          {length ? counter + 1 : 0} of {Math.ceil(length / rows)}
        </Text>
        <InteractiveText
          textType="primary6"
          opacity={0.5}
          underlined
          onClick={handleNext}
        >
          {'Next >'}
        </InteractiveText>
      </Queue>
    </Stack>
  );
};
